// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2O8QW","additionalInfo":"AgreementModal_additionalInfo__16_c4"};